export default __webpack_public_path__ + "static/media/money-white.79fbe671.svg";